import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TAuthPushToCardUserRequestSchema,
  TAuthPushToCardUserResponseSchema,
} from "./authPushToCardUser.schema";

export const authPushToCardUser = (axios: IAxiosInstance) => {
  return async (body: TAuthPushToCardUserRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TAuthPushToCardUserResponseSchema>
    >(`/api/push-to-card/business/auth`, body);

    return response.data;
  };
};
